module.exports = __webpack_public_path__ + "static/media/hyqvia.63a73cfc.png";